import { Alert, Box, CircularProgress } from "@mui/material";
import { useRegisterPageTitle } from "../context/TopBarActionsContext";
import { useWorkflowConfig } from "../hooks/useWorkflow";
import WorkflowCanvas from "./ViewWorkflow/WorkflowCanvas";

export default function ViewWorkflow() {
  // Register top-bar title for the duration of this page.
  useRegisterPageTitle("View Workflow");

  // The canvas only renders the ESS workflow — this page exists as a
  // visual reference for the suggestion state machine, ported from
  // the nmms View Workflow surface (ess-only scope).
  const { data: workflow, isLoading, isError, error } =
    useWorkflowConfig("ess_suggestion");

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <CircularProgress />
      </Box>
    );
  }
  if (isError || !workflow) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Couldn't load the workflow definition.
          {error instanceof Error ? ` ${error.message}` : ""}
        </Alert>
      </Box>
    );
  }

  // AppLayout's children wrapper has `p: { xs: 2, md: 3 }` and a
  // sticky `<Toolbar />` above. Pin the canvas to the remaining
  // viewport (so dagre + React Flow have a real height to lay out
  // against, otherwise the canvas collapses to 0px and nodes render
  // at scale=0.22) AND cancel out the wrapper padding with matching
  // negative margins so the dotted canvas extends edge-to-edge
  // inside the page area.
  return (
    <Box
      sx={{
        width: { xs: "calc(100% + 32px)", md: "calc(100% + 48px)" },
        height: { xs: "calc(100vh - 56px)", md: "calc(100vh - 64px)" },
        m: { xs: -2, md: -3 },
        overflow: "hidden",
      }}>
      <WorkflowCanvas workflow={workflow} />
    </Box>
  );
}
